import { Component, Input, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { trigger, state, style, animate, transition, AnimationEvent } from '@angular/animations';

@Component({
  templateUrl: './alert.component.html',
  styles: [
    `.alert-container {
      display: block;
      position: fixed;
      z-index: 200;
      width: auto;
      left: 0;
    }`
  ],
  animations: [
    trigger(
      'openState',
      [
        state(
          'open',
          style({
            top: '0px'
          })
        ),
        state(
          'closed',
          style({
            top: '-70px'
          })
        ),
        transition('closed => open', animate('300ms ease-out')),
        transition('open => closed', animate('300ms ease-in')),
      ]
    ),
  ]
})
export class AlertComponent implements OnInit, OnDestroy {
  state = 'closed';
  autoCloseTimer: any = undefined;

  @Input() type: string
  @Input() message: string
  onClose: () => void

  @ViewChild('alertContainer')
  alertContainer: ElementRef 

  close() {
    this.onClose();
  }

  ngOnInit() {
    // Auto-close after 3 seconds if success alert
    if(this.type === 'success') {
      this.autoCloseTimer = setTimeout(this.onClose, 3000);
    }
  }

  ngOnDestroy() {
    if(this.autoCloseTimer !== undefined) {
      clearTimeout(this.autoCloseTimer);
    }
  }

  onResize(event: Event) {
    this.updateTransform();
  }

  alertOpened(event: AnimationEvent) {
    if(event.toState === 'open') {
      this.updateTransform();
    }
  }

  updateTransform() {
    let element = this.alertContainer.nativeElement;

    // Center the alert container
    let translate = (window.innerWidth - element.clientWidth) / 2;

    element.style.transform = `translateX(${translate}px)`;
  }
}
